(function () {
  const getMode = () => {
    const mode = document.documentElement.getAttribute('data-mode');
    return mode === 'business' ? 'business' : 'consumer';
  };

  const syncPanels = (root) => {
    if (!root) return;
    const mode = getMode();

    /* Toggle right-column content panels */
    root.querySelectorAll('.faq-hub__panel[data-faq-mode]').forEach((panel) => {
      panel.toggleAttribute('hidden', panel.dataset.faqMode !== mode);
    });

    /* Toggle left-column category navs */
    root.querySelectorAll('.faq-hub__categories[data-faq-mode]').forEach((nav) => {
      nav.toggleAttribute('hidden', nav.dataset.faqMode !== mode);
    });
  };

  const normalize = (value) =>
    value ? value.toString().toLowerCase().trim() : '';

  const setActiveState = (item, active) => {
    if (!item) return;
    const answer = item.querySelector('.collapsible-content__answer');
    item.classList.toggle('active', active);
    if (answer) {
      answer.style.display = active ? 'block' : 'none';
    }
  };

  const setupCategories = (root) => {
    root.querySelectorAll('.faq-hub__categories').forEach((nav) => {
      const buttons = nav.querySelectorAll('.faq-hub__category-item');
      const mode = nav.dataset.faqMode;
      const panel = root.querySelector(`.faq-hub__panel[data-faq-mode="${mode}"]`);
      if (!panel) return;

      const contentItems = panel.querySelectorAll('.faq-hub__content-item:not([data-all-content])');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const category = btn.dataset.category;

          /* Update active button */
          buttons.forEach((b) => b.classList.remove('faq-hub__category-item--active'));
          btn.classList.add('faq-hub__category-item--active');

          /* Show matching content, hide others */
          panel.querySelectorAll('.faq-hub__content-item').forEach((item) => {
            if (item.dataset.category === category) {
              item.setAttribute('data-active', '');
              item.style.display = '';
            } else {
              item.removeAttribute('data-active');
              item.style.display = 'none';
            }
          });

          /* Clear search when switching categories */
          const input = root.querySelector('[data-faq-search]');
          if (input && input.value) {
            input.value = '';
            const clearBtn = root.querySelector('[data-faq-clear]');
            if (clearBtn) clearBtn.hidden = true;
          }
        });
      });
    });
  };

  const setupSearch = (root) => {
    const input = root.querySelector('[data-faq-search]');
    const clearBtn = root.querySelector('[data-faq-clear]');
    if (!input) return;

    if (input.dataset.searchBound) return;
    input.dataset.searchBound = 'true';

    const doFilter = () => {
      const term = normalize(input.value);
      const mode = getMode();

      const visiblePanel = root.querySelector(`.faq-hub__panel[data-faq-mode="${mode}"]:not([hidden])`);
      if (!visiblePanel) return;

      const allContent = visiblePanel.querySelector('[data-all-content]');
      if (!allContent) return;

      const items = Array.from(
        allContent.querySelectorAll('.collapsible-content__item[data-faq-item]')
      );
      const emptyState = allContent.querySelector('[data-faq-empty-search]');

      /* Switch to "All" content when searching, back to category when cleared */
      if (term !== '') {
        visiblePanel.querySelectorAll('.faq-hub__content-item').forEach((item) => {
          if (item.hasAttribute('data-all-content')) {
            item.style.display = '';
            item.setAttribute('data-active', '');
          } else {
            item.style.display = 'none';
            item.removeAttribute('data-active');
          }
        });

        /* Deactivate category buttons */
        const categoryNav = root.querySelector(`.faq-hub__categories[data-faq-mode="${mode}"]`);
        if (categoryNav) {
          categoryNav.querySelectorAll('.faq-hub__category-item').forEach((btn) => {
            btn.classList.remove('faq-hub__category-item--active');
          });
        }
      } else {
        /* Search cleared — revert to first category */
        allContent.style.display = 'none';
        allContent.removeAttribute('data-active');

        const firstContent = visiblePanel.querySelector('.faq-hub__content-item:not([data-all-content])');
        if (firstContent) {
          firstContent.setAttribute('data-active', '');
          firstContent.style.display = '';
        }

        const categoryNav = root.querySelector(`.faq-hub__categories[data-faq-mode="${mode}"]`);
        if (categoryNav) {
          const firstBtn = categoryNav.querySelector('.faq-hub__category-item');
          if (firstBtn) {
            categoryNav.querySelectorAll('.faq-hub__category-item').forEach((b) =>
              b.classList.remove('faq-hub__category-item--active')
            );
            firstBtn.classList.add('faq-hub__category-item--active');
          }
        }
      }

      let visibleCount = 0;
      items.forEach((item) => {
        const questionEl = item.querySelector('.collapsible-content__question');
        const answerEl = item.querySelector('.collapsible-content__answer-inner');
        const text = normalize(questionEl ? questionEl.textContent : '');
        const answerText = normalize(answerEl ? answerEl.textContent : '');
        const isMatch = term === '' || text.includes(term) || answerText.includes(term);

        item.style.display = isMatch ? '' : 'none';
        setActiveState(item, false);

        if (isMatch) visibleCount++;
      });

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }
      if (clearBtn) {
        clearBtn.hidden = input.value.length === 0;
      }
    };

    input.addEventListener('input', doFilter);
    input.addEventListener('keyup', doFilter);

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        input.focus();
        doFilter();
      });
    }
  };

  const alignRightColumn = (root) => {
    if (window.innerWidth < 750) return;
    const left = root.querySelector('.collapsible-content__left');
    const right = root.querySelector('.faq-hub__right');
    const firstCategory = root.querySelector('.faq-hub__categories:not([hidden]) .faq-hub__category-item');
    if (!left || !right || !firstCategory) return;

    const leftTop = left.getBoundingClientRect().top;
    const catTop = firstCategory.getBoundingClientRect().top;
    right.style.paddingTop = (catTop - leftTop) + 'px';
  };

  const init = () => {
    document.querySelectorAll('.faq-hub').forEach((root) => {
      syncPanels(root);
      setupCategories(root);
      setupSearch(root);
      alignRightColumn(root);
    });
  };

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((m) => m.attributeName === 'data-mode')) {
      document.querySelectorAll('.faq-hub').forEach(syncPanels);
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-mode'],
  });

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target.querySelector('.faq-hub');
    if (sectionRoot) {
      syncPanels(sectionRoot);
      setupCategories(sectionRoot);
      setupSearch(sectionRoot);
    }
  });

  document.addEventListener('DOMContentLoaded', init);

  if (document.readyState !== 'loading') {
    init();
  }
})();
